module.exports = __webpack_public_path__ + "static/media/search.abd7ea7c.svg";